import request from '@/config/request.js'
import common from '@/components/common/'
const ApiHelpDoc = request.HelpDoc


export default {
  name: 'two-color-ball',
  components: {
    ...common
  },
  data () {
      return {
        searchQuery: '',
        currentNav: null,
        currentContent: null,
        feedback: {
          category: {id: null},
          title: '',
          content: ''
        },
        helpData: [],
        rules: {
          title: [
            { required: true, message: '请简要描述您的问题', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '请详细描述您遇到的问题，包括重现步骤等信息', trigger: 'blur' }
          ]
        }
      }
  },
  mounted() {
    this.initMenu()
    // this.initContents()
    // 默认选择第一个内容项
    if (this.helpData.length > 0) {
      const firstItem = this.helpData[0];

      if (firstItem.sections && firstItem.sections.length > 0) {
        this.handleSelect(firstItem.sections[0].id);
      } else {
        this.handleSelect(firstItem.id);
      }
    }
  },
  methods: {
     handleBack() {
      this.$router.go(-1)
    },
    initContents (categoryId = 2) {
      ApiHelpDoc.getHelpContents.call(this, {categoryId: categoryId}, (listData) => {
        console.log(listData)
        this.currentContent = listData? listData[0]: []

      })
    },
    initMenu() {
      ApiHelpDoc.getFullCategoryTree.call(this, {}, (listData) => {
        this.helpData = listData
      })
    },
    getNavIcon(item) {
      return item.sections ? 'fa-folder' : 'fa-file';
    },

    getContentIcon(content) {
      if (content.id === '101') return 'fa-info-circle';
      if (content.id === '102') return 'fa-download';
      if (content.id === '301') return 'fa-star';
      if (content.id === '302') return 'fa-magic';
      return 'fa-cog';
    },

    handleSelect(index) {
      this.feedback.category.id = index
      this.currentNav = index;
      this.$refs.scrollableDiv.scrollTop = 0;
      this.initContents(index)
    },

    searchHelp() {
      if (!this.searchQuery.trim()) return;

      const query = this.searchQuery.toLowerCase();
      // 在实际应用中这里应该执行搜索逻辑
      // 这里简单模拟搜索结果
      this.$message({
        message: `执行搜索: ${query}\n在实际应用中，这里会显示搜索结果`,
        type: 'info'
      });
    },

    submitFeedback(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          ApiHelpDoc.saveUserFeedback.call(this, this.feedback, res => {
            this.$message.success(`反馈已提交！\n标题: ${this.feedback.title}`);
            this.$refs[formName].resetFields();
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
